<template>
  <div class="app-container">
    <div class="gap"></div>
    <el-form  ref="queryForm"
             :model="queryParams"
             :inline="true"
             label-width="68px">
      <el-form-item label="老师编号"
                    prop="operName">
        <el-input v-model="queryParams.id"
                  placeholder="请输入操作账号"
                  clearable
                  size="small" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary"
                   icon="el-icon-search"
                   :loading="loading"
                   size="mini"
                   @click="handleQuery">查询</el-button>
        <!-- <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button> -->
      </el-form-item>
    </el-form>
    <!-- <div class="gap">
      <span>我的等级： {{ score/10 <0 ?" 0":score/10 }} 级</span>
        <el-button type="primary"
                   size="mini"
                   @click="logout">退出</el-button>
    <el-row :gutter="10"
            class="mb8">
      <el-col :span="1.5">
        <el-button type="primary"
                   icon="el-icon-plus"
                   size="mini"
                   @click="handleAdd">新增</el-button>
      </el-col>
    </el-row>
   
  </div> -->
  <!-- <div class="gap"></div> -->
    <el-table v-loading="loading"
              :data="list">
      <!-- <el-table-column type="selection" width="55" align="center" /> -->
      <!-- <el-table-column label="日志编号" align="center" prop="operId" /> -->
      <!-- <el-table-column label="产品图片"
                       align="center"
                       prop="img">
         <template slot-scope="scope">
          <img style="width:100px"
               :src="scope.row.img"
               alt="" />
        </template>
      </el-table-column> -->
      <el-table-column label="老师编号"
      label-class-name  = 'title'
                       align="center"
                      :formatter="transOrder"
                       prop="id" />
      <el-table-column label="老师姓名"
      label-class-name  = 'title'
                       align="center"
                       prop="username" />
      <el-table-column label="手机号码"
                       align="center"
                        label-class-name  = 'title'
                       prop="phone" />
                       <el-table-column label="身份"
                       align="center"
                       :formatter = 'shenfenTrans'
                        label-class-name  = 'title'
                       prop="shenfen" />
     
      <el-table-column label="操作"
                       align="center"
                       label-class-name  = 'title'
                       class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button  class="inspect-button"
                     size="mini"
                     type="primary"
                     @click="shenfenUpdate(scope.row)">身份修改</el-button>
          <!-- <el-button v-if="scope.row.judge == '0' && scope.row.state == '1'" class="inspect-button"
                     size="mini"
                     type="primary"
                     @click="handleJudge(scope.row)">评价</el-button>
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-view"
                     @click="handleView(scope.row)">查看</el-button>
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-updata"
                     @click="handleUpdate(scope.row)">修改</el-button>
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-delete"
                     @click="handleDelete(scope.row.id)">删除</el-button> -->
        </template>
      </el-table-column>

    </el-table>

    <el-pagination
      v-show="total>0"
      :total="total"
      @current-change="getList"
      @prev-click = 'getList'
      @next-click="getList"
    />

    <!-- 操作日志详细 -->
    <el-dialog title="身份修改"
               :visible.sync="open"
               :close-on-click-modal="false"
               width="500px"
               append-to-body>
      <el-form ref="form"
               :model="shenFenForm"
               label-width="100px"
               size="mini">
        <el-row>

          <el-col :span="20">
            <el-form-item label="联系方式">
              <el-select v-model="shenFenForm.shenfen" placeholder="请选择">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   :disabled='disabled'
                   @click="submit">确定</el-button>
        <el-button @click="open = false">关闭</el-button>
      </div>
    </el-dialog>


        <!-- 操作日志详细 -->
        <el-dialog title="评价"
               :visible.sync="judgeOpen"
               :close-on-click-modal="false"
               width="500px"
               append-to-body>
      <el-form ref="form"
               :model="form"
               label-width="100px"
               size="mini">
        <el-row>
          <el-col :span="24">
            <el-form-item label="求助内容">
              <el-switch
  style="display: block"
  v-model="judge"
  active-color="#13ce66"
  inactive-color="#ff4949"
  active-text="好评"
  inactive-text="差评">
</el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="评价内容">
              <el-input v-model="form.judge_content"
                        :disabled='disabled'
                        clearable
                        size="small" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   :disabled='disabled'
                   @click="judgeSubmit">确定</el-button>
        <el-button @click="judgeOpen = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { infoAdd,updateInfo,deleteInfo,judge,recordList,orderUpdate, getProdetail, addProduct, deleletProdcut, updateProduct } from '../api/productManage/index'
import { teacherInfo,shenUpdate } from '../api/user/user'
export default {
  name: 'Operlog',
  data () {
    return {
      shenFenForm:{},
      options: [{
          value: '0',
          label: '专职老师'
        }, {
          value: '1',
          label: '大学生/毕业生'
        }, {
          value: '2',
          label: '明星老师'
        }, {
          value: '3',
          label: '金牌老师'
        }],
        value: '',
      nianji: [{
				key: '00',
				lable: '学前'
			},
			{
				key: '01',
				lable: '一年级'
			},
			{
				key: '02',
				lable: '二年级'
			},
			{
				key: '03',
				lable: '三年级'
			},
			{
				key: '04',
				lable: '四年级'
			},
			{
				key: '05',
				lable: '五年级'
			},
			{
				key: '06',
				lable: '六年级'
			},

			{
				key: '07',
				lable: '初一'
			},
			{
				key: '08',
				lable: '初二'
			},
			{
				key: '09',
				lable: '初三'
			},
			{
				key: '10',
				lable: '高一'
			},
			{
				key: '11',
				lable: '高二'
			},
			{
				key: '12',
				lable: '高三'
			},
			{
				key: '13',
				lable: '大学'
			},
			{
				key: '14',
				lable: '其他'
			}
		],
      score:'0',
      judge: true,
      pageIndex:1,
      pageSize:10,
      // 禁用状态
      disabled: false,
      queryParams: {},
      loading: false,
      // table 列表数据
      list: [],
      // 总条数
      total:0,
      // dialog 弹框
      open: false,
      judgeOpen:false,
      // 弹框 表单
      form: {}
    }
  },
  created () {
    // this.handleQuery();
  },
  methods: {
    //  
    shenfenUpdate(row){
      debugger
      this.open =  true;
      this.shenFenForm = row;
    },
    // 翻译性别
    transOrder (row) {
      return  row.id
    },
     // 翻译性别
     transGender (row) {
      return row.gender == '1' ? '男' :'女'
    },
    //  身份翻译
    shenfenTrans(row){
      let obj = {
        "0":'专职老师',
        "1":'大学生/毕业生',
        '2':'明星老师',
        '3':'金牌老师',
      } 
      return obj[row.shenfen]
    },
    // 翻译求助状态
    stateTrans (row) {
      let obj = {
        "0":'待审核',
        "1":'待分配',
        '2':'已分配'
      }
      return obj[row.state]
    },
    // 翻译评价类型
    transGrade (row) {
      let list = this.nianji;
      for(let i=0;i<list.length;i++){
        if(list[i].key-0 == row.grade){
          return list[i].lable
        }
      }
      
    },
    access(row){
      let params = {
        id:row.id,
        state:'2',
        teacher_id:row.openid
      }
      debugger
      this.$confirm('确认分配吗？')
          .then(()=> {
            orderUpdate(params).then(res => {
        this.handleQuery()
      })
          })
          .catch(_ => {});
      
     

    },
    //  退出
    logout(){
      localStorage.clear();
      this.$router.push('/')
    },
    // 新增按钮
    handleAdd () {
      this.open = true
      this.disableFun(false)
      this.form.id = undefined
    },
    // 确定按钮
    submit () {
      debugger
      shenUpdate(this.shenFenForm).then(res => {
          console.log(res)
          this.open = false
          this.$message.success('修改成功')
          debugger
          this.handleQuery()
        })
      
    },
        // 查看
        handleJudge (row) {
          debugger
      this.judgeOpen = true
      this.form.id = row.id
      this.form.help_userid = row.help_userid

    },
       // 确定按钮
       judgeSubmit () {
      console.log(this.form)
      if(this.judge){
        this.form.judge = '1'
      }else{
        this.form.judge = '2'
      }
      if(!this.form.judge_content){
       return this.$message.error('请添加评价')
      }
      judge(this.form).then(res => {
          console.log(res)
          this.open = false
          this.$message.success('评价成功')
          this.judgeOpen = false
          this.handleQuery()
        })
      
    },
    // 查看
    handleView (row) {
      debugger
      this.open = true
      this.form = Object.assign({},row)
      this.disableFun(true)

    },
    // 修改按钮
    handleUpdate (row) {
      this.handleView(row)
      this.disableFun(false)
    },
    /**
     * @desc 禁用逻辑
     * @param {Blean}
    */
    disableFun (Blean) {
      this.disabled = Blean
    },
    // 查询按钮
    handleQuery () {
      let params= {
       id:this.queryParams.id 
      }
      if(!params.id){
        return
      }
      teacherInfo(params).then(res => {
        debugger
        this.list = res.data.list;
      })
    },
    // 删除按钮
    handleDelete (id) {
      let obj = { id: id }
      deleteInfo(obj).then(res => {
        this.$message.success('删除成功')
        this.handleQuery()
      })
    },
    //  上一页面
    preClick(e){
      debugger
      this.pageIndex = e;
      if(pageIndex<=1){return}
      this.handleQuery()
    },
    // 下一页
    preClick(){
      let pageIndex = this.pageIndex +1;
      
      if(pageIndex * this.pageSize >= this.total){
        return
      }
      this.pageIndex = pageIndex;
      this.handleQuery()
    },
    // 获取列表
    getList (e) {
      this.pageIndex = e
      let params = {
        pageIndex:this.pageIndex,
        pageSize:this.pageSize,
      }
      recordList(params).then(res => {
        debugger
        this.list = res.data.list;
        this.total = res.data.total
        console.log(this.total)
      })
    }
  }
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.gap{
  margin: 30px 10px;
}
.title{
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/infoManage/teacherInfo.vue